//Header fix

let header = document.getElementsByTagName('header');
let headerContainer = header[0].getElementsByClassName('container');


window.onscroll = function(e) {

    if (this.oldScroll > this.scrollY && this.scrollY > 200) {
        header[0].classList.add('fixed');
        // main[0].classList.add('fixed');
    } else {
        // main[0].classList.remove('fixed');
        header[0].classList.remove('fixed');
    }

    this.oldScroll = this.scrollY;

}